import * as Types from '../generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type UpdateTravelSettingsMutationVariables = Types.Exact<{
  payload: Types.UpdateTravelSettingsRequest;
}>;

export type UpdateTravelSettingsMutation = {
  __typename?: 'Mutation';
  updateTravelSettings: {
    __typename?: 'TravelSettings';
    currencyCode?: Types.TravelCurrencyCode | null;
    checkInDate?: string | null;
    checkOutDate?: string | null;
    datesMatchingReminder?: boolean | null;
  };
};

export const UpdateTravelSettingsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTravelSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTravelSettingsRequest' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTravelSettings' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'datesMatchingReminder' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateTravelSettingsMutationFn = Apollo.MutationFunction<UpdateTravelSettingsMutation, UpdateTravelSettingsMutationVariables>;

/**
 * __useUpdateTravelSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTravelSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTravelSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTravelSettingsMutation, { data, loading, error }] = useUpdateTravelSettingsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateTravelSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTravelSettingsMutation, UpdateTravelSettingsMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateTravelSettingsMutation, UpdateTravelSettingsMutationVariables>(UpdateTravelSettingsDocument, baseOptions);
}
export type UpdateTravelSettingsMutationHookResult = ReturnType<typeof useUpdateTravelSettingsMutation>;
export type UpdateTravelSettingsMutationResult = Apollo.MutationResult<UpdateTravelSettingsMutation>;
export type UpdateTravelSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateTravelSettingsMutation, UpdateTravelSettingsMutationVariables>;
